import 'events-polyfill';
import GameEmitters from "./game";
import WebEmitters from "./web";

export default class Emitters {
    constructor(gb) {
        Object.assign(this, { gb });

        // this.emitters = Object.assign(new GameEmitters(gb).exportEmitters(), new WebEmitters(gb).exportEmitters());
        this.emit = {
            game: new GameEmitters(gb),
            web: new WebEmitters(gb)
        }

    }

    stopAutoSpin() {
        this.emitters.stopAutoSpin();
    }
}
